<template>
  <div class="page-container">
    <div class="main">
      <page
          :url="url"
          :form="form"
          :paginationSwitch="false"
          :isCustomization="true"
          ref="pageRef"
          @request-result="onResult"
          @reset="reset"
      >
        <template slot="buttonArea">
          <el-button :loading="loading" type="primary" size="small" @click="addUser">
            {{ $t('text.existingUsers') }}
          </el-button>
          <el-button :loading="loading" type="primary" size="small" @click="handleBatchEdit"
                     :disabled="selectedKeywords.length === 0">
            {{ $t('text.batchEdit') }}
          </el-button>
        </template>

        <template slot="customization">
          <div v-if="Object.keys(tableData).length > 0" class="tabs-wrapper">
            <el-tabs v-model="activeTab" type="border-card">
              <el-tab-pane
                  v-for="(list, groupName) in tableData"
                  :key="groupName"
                  :label="getGroupLabel(groupName)"
                  :name="groupName"
              >
                <el-table :data="list" border stripe style="width: 100%" @selection-change="handleSelectionChange">
                  <el-table-column type="selection" width="50" align="center"/>
                  <el-table-column prop="description" :label="$t('text.description')"/>
                  <el-table-column
                      header-align="center"
                      :label="$t('text.atUserId')"
                      width="300"
                  >
                    <template slot-scope="scope">
                      <template v-if="scope.row.atUserNames">
                        <el-tag
                            v-for="name in scope.row.atUserNames.split(',')"
                            :key="name"
                            v-if="name.trim()"
                            style="margin-right: 5px; margin-bottom: 5px;"
                            type="success"
                            effect="dark"
                        >
                          {{ name.trim() }}
                        </el-tag>
                      </template>
                      <span v-else style="color: #999"> -- </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                      :label="$t('text.actions')"
                      width="120px"
                      align="center"
                  >
                    <template slot-scope="scope">
                      <el-button type="primary" size="mini" plain @click="handleEdit(scope.row)">
                        {{ $t('text.edit') }}
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
          <el-empty v-else :description="$t('text.noData')"/>
        </template>
      </page>

      <MessagingAppAtEdit v-if="showAtUserEdit"
                          :show.sync="showAtUserEdit"
                          :formData="formData"
                          :appUserInfo="appUserInfo"/>

      <MessagingAppAtBatchEdit v-if="showBatchAtUserEdit"
                               :show.sync="showBatchAtUserEdit"
                               :data="selectedKeywords"
                               :appUserInfo="appUserInfo"/>

      <MessagingAppAtUserSelect v-if="showAtUserList"
                                :show.sync="showAtUserList"
                                :appUserInfo="appUserInfo"
                                :roleList="roleList"
                                @update-messaging-user-info="selectMessagingUserInfo"/>

    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import MessagingAppAtEdit from './components/messagingAppAt/MessagingAppAtEdit.vue'
import MessagingAppAtBatchEdit from './components/messagingAppAt/MessagingAppAtBatchEdit.vue'
import MessagingAppAtUserSelect from './components/messagingAppAt/MessagingAppAtUserSelect.vue'

export default {
  components: {
    page: Page,
    MessagingAppAtEdit: MessagingAppAtEdit,
    MessagingAppAtBatchEdit: MessagingAppAtBatchEdit,
    MessagingAppAtUserSelect: MessagingAppAtUserSelect
  },
  data() {
    return {
      loading: false,
      showAtUserEdit: false,
      showBatchAtUserEdit: false,
      showAtUserList: false,
      url: '/messagingAppKey/selectList',
      tableData: {},
      activeTab: '',
      formData: {},
      data: {},
      roleList: [],
      appUserInfo: [],
      multipleSelection: null,
      selectedKeywords: [],
      form: {},
      groupLabels: {
        MONITOR: '监控告警 (Monitoring)',
        OPERATE: '操作告警 (Operations)',
        SECURITY: '资安告警 (Security)'
      }
    };
  },
  methods: {
    onResult(data) {
      if (data && Object.keys(data).length > 0) {
        this.tableData = data;
        if (!this.activeTab || !data[this.activeTab]) {
          this.activeTab = Object.keys(data)[0];
        }
      } else {
        this.tableData = {};
      }
      this.loading = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.selectedKeywords = val.map(row => {
        return row.keyword;
      });
    },
    reset() {
    },
    getGroupLabel(key) {
      return this.groupLabels[key] || key;
    },
    handleEdit(row) {
      this.formData = row;
      this.showAtUserEdit = true;
    },
    handleBatchEdit() {
      this.showBatchAtUserEdit = true;
    },
    addUser() {
      this.showAtUserList = true;
    },
    selectMessagingUserInfo() {
      this.$axios
          .get("/messagingAppUserInfo/selectOption", {params: {}})
          .then((res) => {
            this.roleList = [...new Set(res.data?.map(item => item.role) || [])];
            this.appUserInfo = res.data;
          });
    }
  },
  created() {
    this.selectMessagingUserInfo();
    this.$nextTick(() => {
      this.$refs.pageRef.onSubmit();
    });
  },
};
</script>

<style lang="scss" scoped>
.tabs-wrapper {
  margin-top: 20px;

  ::v-deep .el-tabs--border-card {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  }

  ::v-deep .el-tabs__content {
    padding: 15px;
  }
}
</style>